import { Popover, PopoverProps } from 'antd';
import { memo } from 'react';
import { PreviewWrapper } from 'views/Assistant/Department/components/AssignReceptionConfColumn';
import StoreScopesPreview from './StoreScopesPreview';
import { useTranslate } from '@tolgee/react';
import moreSvg from 'views/Knowledge/assets/more.svg';
import { getStoreCount } from './Result';

export interface PopoverPreviewProps extends PopoverProps {
  value: General.StoreScope[];
}

function PopoverPreview(props: PopoverPreviewProps) {
  const { value, ...otherProps } = props;

  const { t } = useTranslate();

  return (
    <div>
      {t('ViewBlockList.{x}家店铺', { count: getStoreCount(value) })}
      <Popover
        content={
          <PreviewWrapper>
            <StoreScopesPreview value={value} showSearch={false} showTitle={false} />
          </PreviewWrapper>
        }
        {...otherProps}
      >
        <img src={moreSvg} alt="more" className="w-[16px] ml-[4px] cursor-pointer" />
      </Popover>
    </div>
  );
}

export default memo(PopoverPreview);
